// Import dependencies
import {
  Finger,
  FingerCurl,
  FingerDirection,
  GestureDescription,
} from "fingerpose";

// Define Gesture Description
export const leftDirection = new GestureDescription("left");

// Thumb
leftDirection.addCurl(Finger.Thumb, FingerCurl.NoCurl, 1.0);
leftDirection.addDirection(Finger.Thumb, FingerDirection.VerticalUp, 0.25);

// Index
leftDirection.addCurl(Finger.Index, FingerCurl.NoCurl, 1.0);
leftDirection.addDirection(Finger.Index, FingerDirection.HorizontalRight, 0.8);

for (let finger of [Finger.Middle, Finger.Ring, Finger.Pinky]) {
  leftDirection.addCurl(finger, FingerCurl.FullCurl, 0.75);
  leftDirection.addDirection(finger, FingerDirection.HorizontalLeft, 0.25);
}

export const rightDirection = new GestureDescription("right");

// Thumb
rightDirection.addCurl(Finger.Thumb, FingerCurl.NoCurl, 1.0);
rightDirection.addDirection(Finger.Thumb, FingerDirection.VerticalUp, 0.25);

// Index
rightDirection.addCurl(Finger.Index, FingerCurl.NoCurl, 1.0);
rightDirection.addDirection(Finger.Index, FingerDirection.HorizontalLeft, 0.8);

for (let finger of [Finger.Middle, Finger.Ring, Finger.Pinky]) {
  rightDirection.addCurl(finger, FingerCurl.FullCurl, 0.75);
  rightDirection.addDirection(finger, FingerDirection.HorizontalRight, 0.25);
}

export const down = new GestureDescription("down");

// Thumb
down.addCurl(Finger.Thumb, FingerCurl.NoCurl, 1.0);
down.addDirection(Finger.Thumb, FingerDirection.VerticalUp, 0.25);

for (let finger of [Finger.Middle, Finger.Index, Finger.Ring, Finger.Pinky]) {
  down.addCurl(finger, FingerCurl.FullCurl, 0.75);
  down.addDirection(finger, FingerDirection.VerticalDown, 0.25);
}
export const up = new GestureDescription("up");

// Thumb
up.addCurl(Finger.Thumb, FingerCurl.NoCurl, 1.0);
up.addDirection(Finger.Thumb, FingerDirection.VerticalUp, 0.25);

for (let finger of [Finger.Middle, Finger.Index, Finger.Ring, Finger.Pinky]) {
  up.addCurl(finger, FingerCurl.NoCurl, 0.75);
  up.addDirection(finger, FingerDirection.VerticalUp, 0.25);
}
